import { useTranslation } from 'react-i18next'

import Image from 'shared/images/plane_image.png'
import { useDialogBottomSheet } from 'shared/ui/dialog-bottom-sheet/lib'

import { AppIcon } from '../app-icon'
import { AllIcons } from '../app-icon/types'
import { BlockInfo } from '../block-info'
import { Paper } from '../paper'

import s from './styles.module.scss'

export const CharterButton = () => {
  const { t } = useTranslation()

  const { openDialog } = useDialogBottomSheet()

  const onShowInfo = () => {
    const listInfo = [
      {
        icon: AllIcons.ARROW_SHORT,
        title: 'charter_info.title_first',
        description: 'charter_info.description_first',
      },
      {
        icon: AllIcons.DISCOUNT,
        title: 'charter_info.title_second',
        description: 'charter_info.description_second',
      },
      {
        icon: AllIcons.WARNING,
        title: 'charter_info.title_third',
        description: 'charter_info.description_third',
      },
      {
        icon: AllIcons.ROYAL,
        title: 'charter_info.title_forth',
        description: 'charter_info.description_forth',
      },
    ]

    openDialog({
      child: (
        <div className={s.difficultInfoWrapper}>
          <img
            src={Image}
            className={s.image}
          />

          <div className={s.header}>
            <p className={s.title}>{t('charter_info.title')}</p>
            <p className={s.subTitle}>{t('charter_info.description')}</p>
          </div>

          {listInfo?.map((item, index) => (
            <div
              className={s.blockInfo}
              key={index + item.icon}
            >
              <BlockInfo
                icon={item.icon}
                title={t(item.title)}
                description={t(item.description)}
              />
            </div>
          ))}
        </div>
      ),
    })
  }

  return (
    <div
      className={s.wrapper}
      onClick={onShowInfo}
    >
      <Paper padding={[16]}>
        <div className={s.container}>
          <div className={s.left}>
            <AppIcon
              id={AllIcons.CHARTER}
              className={s.charter}
              height={24}
              width={24}
            />

            {t('charter')}
          </div>

          <AppIcon
            id={AllIcons.ARROW_RIGHT}
            className={s.arrow}
          />
        </div>
      </Paper>
    </div>
  )
}
